import RegistrationPayment from './RegistrationPayment';

export default RegistrationPayment;
